import ZRadio from './ZRadio.vue'

export default ZRadio
